'use strict';
require('../../modules/es.object.values');
var path = require('../../internals/path');

module.exports = path.Object.values;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/es/object/values.js
// module id = 343
// module chunks = 0